import { render, staticRenderFns } from "./action-hide.vue?vue&type=template&id=2f4b46c4&"
import script from "./action-hide.vue?vue&type=script&lang=js&"
export * from "./action-hide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports